import {
  FETCH_PAGINATED_SUBSCRIBER_LIST,
  FETCH_ALL_SUBSCRIBER_LIST,
  FETCH_CURRENT_SUBSCRIBER_LIST,
  SET_MODIFIED_CLIENT_GROUP,
  SET_CANCEL_CLIENT_GROUP_ADD,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_SUBSCRIBER_LIST](state, { subscriberList, pagination }) {
    state.items = subscriberList;
    state.pagination = pagination;
  },

  [FETCH_ALL_SUBSCRIBER_LIST](state, subscriberList) {
    state.all = subscriberList;
  },

  [FETCH_CURRENT_SUBSCRIBER_LIST](state, subscriberList) {
    state.current = subscriberList;
  },

  [SET_MODIFIED_CLIENT_GROUP](state, modifiedClientGroup) {
    state.modifiedClientGroup = modifiedClientGroup;
  },

  [SET_CANCEL_CLIENT_GROUP_ADD](state, cancelClientGroupAdd) {
    state.cancelClientGroupAdd = cancelClientGroupAdd;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/subscriberList/mutations.js